<template>
    <div class="container-view">
      <Breadcrumbs />
      <div class="row col-12 container-titles" style="display: flex">
        <div class="header-title col-10">Entidad {{ dataEntidad.name }}</div>
        <div class="col-2" style="padding-top: 24px; align-items: flex-end">
          <q-btn
            data-cy="save-Entidad"
            style="width: 100%; margin-left: 0 !important"
            color="primary"
            label="Guardar"
            icon="save"
            @click="isNew ? emitNew() : emitgeneralSave()"
            :loading="isLoadingButton"
          />
        </div>
      </div>
      <div class="row col-12 full-height">
        <div class="col-5 right-container">
          <Informacion
            :dataEntidad="dataEntidad"
            :isNew="isNew"
          />
        </div>
        <div class="col-7" v-if="!isNew">
          <UsuariosAdmin
            :dependecyApp="dataEntidad"
            :requestUser="requestAdmin"
            :enableAuthorize="usuariosAdmin.enableAuthorize"
            :showDeleteButton="usuariosAdmin.enableDelete"
            :showEditButton="false"
            :showUsername="false"
            :showCompany="false"
            :showLocale="false"
            :title="'Administradores'"
          />
        </div>
      </div>
      <div class="row bottom-container" id="group-container">
      <div class="col-12" v-if="!isNew">
        <Usuarios
          :dependecyEntidad="dataEntidad"
          :arrayUsuarios="arrayUsuarios"
          :requestUser="requestUser"
          :enableAuthorize="true"
          :showDeleteButton="true"
          :showEditButton="false"
          :showUsername="true"
          :showCompany="true"
          :showLocale="false"
          :title="'Usuarios'"
        />
      </div>
    </div>
      <div class="row col-12">
        <div class="col-12" id="group-container">
          <ServiciosListado
            :dataEntidad="dataEntidad"
            :isNew="isNew"
          />
        </div>
      </div>
    </div>
  </template>
<script>

import Usuarios from '@/components/Usuarios/components/ListadoEntidad.vue';
import UsuariosAdmin from '@/components/Usuarios/components/ListadoAdminEntidad.vue';
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Loading from '@/components/shared/mixins/Loading.js';
import Informacion from '../components/Informacion.vue';
import Resources from '@/components/shared/mixins/Resources.js';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import ServiciosListado from '../components/ServicioListado.vue';
import Vue from 'vue';

export default {
  components: {
    Informacion,
    Usuarios,
    ServiciosListado,
    Breadcrumbs,
    UsuariosAdmin
  },
  mixins: [Message, Validation, Loading, Resources],
  data: function () {
    return {
      arrayUsuarios: [],
      requestUser: {
        list: null,
        count: null,
        filter: null
      },
      requestAdmin: {
        list: null,
        count: null,
        filter: null
      },
      dataEntidad: { },
      isLoading: false,
      isNew: false,
      isLoadingButton: false,
      checkSave: {
        isInfoSave: null,
        existError: false
      },
      events: {
        saveEntidad: 'APLICACION_ACTUALIZAR_INFORMACION',
        saveServicios: 'EJECUCION_GUARDAR_SERVS'
      },
      usuariosAdmin: {
        enableAuthorize: false,
        enableDelete: false
      }
    };
  },
  methods: {
    async emitNew () {
      // Reset variables
      this.resetSaved();
      this.$eventHub.$emit(this.events.saveEntidad, {
        callback: (x) => {
          this.dataEntidad.id = x.data.id;
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
          this.$eventHub.$emit(this.events.saveServicios, {
            callback: (x) => {
              this.checkSave.isServSave = x.status;
              this.checkSaved();
              this.$router.push({
                name: 'entidades'
              });
            }
          });
        },
        rejected: (x) => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    async emitgeneralSave () {
      // Reset variables
      this.resetSaved();
      this.$eventHub.$emit(this.events.saveEntidad, {
        callback: (x) => {
          this.dataEntidad = x.data;
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
          this.$eventHub.$emit(this.events.saveServicios, {
            callback: (x) => {
              this.checkSave.isServSave = x.status;
              this.checkSaved();
              this.$router.push({
                name: 'entidades'
              });
            }
          });
        },
        rejected: (x) => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    resetSaved () {
      this.isLoadingButton = true;
      this.checkSave.existError = false;
      this.checkSave.isInfoSave = null;
    },
    checkSaved () {
      if (this.checkSave.isInfoSave && this.checkSave.isServSave) {
        this.showMessage('Datos guardados con éxito.');
        // Stop Loading Button
        this.isLoadingButton = false;
      } else if (
        (this.checkSave.isInfoSave === false || this.checkSave.isServSave === false) &&
          this.checkSave.existError === false
      ) {
        this.checkSave.existError = true;
        this.showError('No se han podido guardar los datos.');
        // Stop Loading Button
        this.isLoadingButton = false;
      }
    },
    async _callServiciosData () {
      let request = {};
      this.showLoading();
      request = {
        controller: '/Servicios'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          Vue.set(this.dataEntidad, 'listSignedServiceResponses', response.data);
          this.hideLoading();
        })
        .catch(err => {
          this.showError(err.message);
        });
    },
    async getInfoEntidad (idEntidad = null) {
      this.showLoading();

      if (!idEntidad) {
        this.showError('No es una Entidad válida.');
        this.$router.push({ name: 'Entidades' });
      }

      let requestEntidad = {
        controller: '/Entidad/' + idEntidad,
        data: {},
        filter: {}
      };

      let requestUsers = {
        controller: this.requestUser.list,
        data: {},
        filter: {}
      };

      await this.$store
        .dispatch('PF/getSuit', requestEntidad)
        .then(async (response) => {
          let data = response.data;
          data.id = idEntidad;
          data.resources = await this.getResources('Entidad', idEntidad);
          this.dataEntidad = data;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });

      await this.$store
        .dispatch('PF/getSuit', requestUsers)
        .then(async (response) => {
          let data = response.data;
          data.id = idEntidad;
          data.resources = await this.getResources('Entidad', idEntidad);
          this.arrayUsuarios = data;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    usuariosAdminPermissions () {
      const isSuperAdmin = this.$store.getters['PF/isSuperAdmin'];

      if (isSuperAdmin) {
        this.usuariosAdmin.enableAuthorize = true;
        this.usuariosAdmin.enableDelete = true;
      }
    }
  },
  async created () {
    this.usuariosAdminPermissions();

    const idEntidad = this.$route.params.idEntidad;
    if (idEntidad) {
      this.requestUser.list = `/User/Entidad/${idEntidad}`;
      this.requestAdmin.list = `/AdminEntidad/Users/${idEntidad}`;
      this.requestAdmin.count = `/AdminEntidad/Users/${idEntidad}/Count`;
      await this.getInfoEntidad(idEntidad);
    } else {
      this.isNew = true;
    }

    if (this.isNew) {
      await this._callServiciosData();
    }
  }
};
</script>
  <style lang="scss" scoped>

  .right-container {
    padding-right: 32px;
  }

  #group-container {
    padding-top: 32px;
  }
  </style>
